import { Wikis } from '@carbon/icons-react';
import styled from '@emotion/styled';
import { COLORS, DARK_COLORS } from '@tablekit/theme';

import { growOnHover } from 'utils/common.styles';
import { BREAKPOINTS } from 'utils/constants';

export const PageWrapper = styled.div`
  display: flex;
`;

export const LoginWrapper = styled.div`
  overflow-x: hidden;
  position: relative;
  height: 100vh;
  background-color: ${COLORS.PURPLE.L7};

  a {
    color: ${COLORS.PURPLE.L7};
  }
`;

export const NoticesWrapper = styled.div`
  overflow-x: hidden;
  position: relative;
  height: 100vh;
  width: 0;
  flex-shrink: 0;
  background-color: ${({ theme }) => theme.colors.surface};
`;

export const Content = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  top: 160px;
  width: 100%;

  @media (max-width: ${BREAKPOINTS.tablet}) {
    top: 80px;
  }
`;

export const NoticesContent = styled(Content)`
  top: 120px;
  height: calc(100% - 120px);
`;

export const TriangleWrapper = styled.div`
  height: var(--height);
  width: 100vw;
  transition: height 0.3s ease-in;
`;

export const Triangle = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
  display: block;
  clip-path: polygon(0 0, 100% 0, 100% 95%, 0 100%);
  background-color: ${({ theme }) => theme.colors.primary2};
`;

export const LogoWrapper = styled.div`
  position: absolute;
  width: 230px;
  top: var(--spacing-l7);
  left: var(--spacing-l7);

  @media (max-width: ${BREAKPOINTS.tablet}) {
    width: 170px;
    top: var(--spacing-l5);
    left: var(--spacing-l5);
  }
`;

export const LanguageSelectorWrapper = styled.div`
  position: absolute;
  top: var(--spacing-l7);
  right: var(--spacing-l7);

  @media (max-width: ${BREAKPOINTS.tablet}) {
    right: var(--spacing-l5);
    top: var(--spacing-l5);
  }
`;

export const SupportOptionsWrapper = styled.div`
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-l3);
`;

export const Option = styled.div`
  width: 120px;
  height: 100px;
  text-align: center;
  cursor: pointer;

  a {
    color: white;
    text-decoration: none;
  }
`;

export const GrowWrapper = styled.button<{ isDark?: boolean }>`
  ${growOnHover};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const LangText = styled.h3`
  font-weight: 400;
  margin-right: var(--spacing-l4);
  display: inline-block;
  text-transform: uppercase;
`;

export const LangIcon = styled(Wikis)`
  vertical-align: bottom;
`;

export const OptionLabel = styled.p`
  color: white;
  margin-top: var(--spacing-l3);
`;

export const OptionWrapper = styled.div`
  opacity: 0.8;
  transition: opacity 0.3s ease-in;
  ${growOnHover};

  &:hover {
    opacity: 1;

    ${OptionLabel} {
      opacity: 1;
    }
  }
`;

export const FooterWrapper = styled.div`
  margin: var(--spacing-l7) var(--spacing-l4);
  color: ${COLORS.PURPLE.L3};
  text-align: center;

  a {
    color: ${DARK_COLORS.textSubtle};
    margin: 0 var(--spacing-l3);
    transition: color 0.3s ease-in;

    &:hover {
      color: white;
    }
  }
`;
